import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "prod-options" };
const _hoisted_2 = { class: "prod-options__label" };
const _hoisted_3 = { class: "prod-options__list" };
const _hoisted_4 = ["onClick"];
const _hoisted_5 = ["name", "checked"];
const _hoisted_6 = { class: "prod-option__label" };
const _hoisted_7 = { key: 0 };
import { inject, ref, watch } from "vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'FilterSelector',
    props: /*@__PURE__*/ _mergeModels({
        name: { type: String, required: true },
        title: { type: String, required: true },
        items: { type: Array, required: true },
    }, {
        "modelValue": { required: false },
        "modelModifiers": {},
    }),
    emits: ["update:modelValue"],
    setup(__props) {
        const props = __props;
        const modelValue = _useModel(__props, "modelValue");
        const interacted = inject('interacted', ref(false));
        function computeActiveFilter(items) {
            modelValue.value = items.find(item => item.id === modelValue.value?.id)
                ?? items.find(item => item.volume && parseInt(item.volume) >= 15) ?? items[0];
        }
        watch(() => props.items, computeActiveFilter);
        computeActiveFilter(props.items);
        function onClick(item) {
            interacted.value = true;
            modelValue.value = item;
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, _toDisplayString(__props.title), 1 /* TEXT */),
                _cache[2] || (_cache[2] = _createTextVNode()),
                _createElementVNode("ul", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item) => {
                        return (_openBlock(), _createElementBlock("li", {
                            class: "prod-options__item",
                            key: item.id
                        }, [
                            _createElementVNode("label", {
                                class: _normalizeClass(["prod-option", { 'is-na': item.disabled }]),
                                onClick: ($event) => (onClick(item))
                            }, [
                                _createElementVNode("input", {
                                    type: "radio",
                                    class: "prod-option__input",
                                    name: __props.name,
                                    checked: item.id === modelValue.value?.id
                                }, null, 8 /* PROPS */, _hoisted_5),
                                _cache[0] || (_cache[0] = _createTextVNode()),
                                (item.color_code)
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: _normalizeClass(["prod-option__clr", `prod-option__clr--${item.color_code}`])
                                    }, null, 2 /* CLASS */))
                                    : _createCommentVNode("v-if", true),
                                _cache[1] || (_cache[1] = _createTextVNode()),
                                _createElementVNode("span", _hoisted_6, [
                                    _createTextVNode(_toDisplayString(item.name) + " ", 1 /* TEXT */),
                                    (item.flag)
                                        ? (_openBlock(), _createElementBlock("em", _hoisted_7, _toDisplayString(item.flag), 1 /* TEXT */))
                                        : _createCommentVNode("v-if", true)
                                ])
                            ], 10 /* CLASS, PROPS */, _hoisted_4)
                        ]));
                    }), 128 /* KEYED_FRAGMENT */))
                ])
            ]));
        };
    }
});
